import { Array } from "runtypes";
import type { Static } from "runtypes";
import { Question } from "./Question";

export const GetQuestions = Array(Question);

export type GetQuestions = Static<typeof GetQuestions>;
